export default (Alpine) => {

	Alpine.directive('select-location-changer', (el, { cleanup }) => {

		const $el = $(el);

		// Make active
		$el.attr('disabled', null);

		// Attach listener
		$el.on('change', (e) => {

			const url = e.currentTarget.value;

			if (url && url !== '#') {

				window.location.href = url;

			}

		});

	});

};